import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SidebarMenuWidthState {
  /**
   * The menu card's width in pixels, dragged from the pinned card's edge and
   * kept across visits on this browser; null keeps the default
   * (--sidebar-drawer-width or --sidebar-flyout-width). Every menu takes it,
   * hovering or pinned, so pinning never changes a menu's width.
   */
  width: number | null
  /** While the edge is dragged, so the sidebar follows the pointer without easing. */
  isResizing: boolean
  setWidth: (width: number | null) => void
  setResizing: (isResizing: boolean) => void
}

export const useSidebarMenuWidthStore = create<SidebarMenuWidthState>()(
  persist(
    (set) => ({
      width: null,
      isResizing: false,
      setWidth: (width) => set({ width }),
      setResizing: (isResizing) => set({ isResizing }),
    }),
    {
      name: 'arvoke.sidebar.menuWidth',
      partialize: (state) => ({ width: state.width }),
    }
  )
)
